import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { BusinessPropType } from 'containers/Businesses/props'
import { selectTotalBusinesses } from 'store/businesses'
import { fetchBusinessReviews, setDisplayedBusiness } from 'store/business'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import styles from './BusinessesList.scss'
import VerticalTable from 'UI/VerticalTable/VerticalTable'
import { businessesColumns } from './utils'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'

export default function BusinessesList({
  isLoadingInitial = false,
  isLoadingNextBatch = false,
  businesses,
  onScroll,
  containerRef,
  navigationRef,
  headerRef,
  summaryRef,
}) {
  const dispatch = useDispatch()

  const { trackEvent } = useMatomo()

  const totalBusinesses = useSelector(selectTotalBusinesses)

  return (
    <VerticalTable
      enableColumnPicker
      pageSize={100}
      dataSource={businesses}
      columns={businessesColumns}
      topBarContainerClassName={styles.topBarContainer}
      containerRef={containerRef}
      additionalRefs={[navigationRef, headerRef, summaryRef]}
      fetchNextPage={onScroll}
      total={totalBusinesses}
      loading={isLoadingNextBatch}
      removeFromPickerColumns={[COLUMNS_IDS.businessName]}
      rowClassName={styles.tableRow}
      onRow={record => {
        return {
          onClick: () => {
            dispatch(fetchBusinessReviews({ businessId: record.id }))
            dispatch(setDisplayedBusiness({ business: record }))

            trackEvent({
              category: 'Business Mapper List',
              action: `User clicked on Business ${record.businessName}`,
            })
            window.open(`${window.location.origin}/singleBusiness/${record.id}`, '_blank')
          },
        }
      }}
      diffHeight={50}
    />
  )
}

BusinessesList.propTypes = {
  isLoadingInitial: PropTypes.bool,
  isLoadingNextBatch: PropTypes.bool,
  businesses: PropTypes.arrayOf(BusinessPropType).isRequired,
  onScroll: PropTypes.func.isRequired,
}
